import React from 'react';

import { useIntl } from 'react-intl-next';

import { fg } from '@atlaskit/platform-feature-flags';

import { FilterProductIcon } from '../../../../../common/ui/filters/filter-product-icon';
import type { FilterProps } from '../../../../../common/ui/filters/product-filters/types';
import { ToggleFilter } from '../../../../../common/ui/filters/toggle-filter';
import { useBooleanFilter } from '../../../../../controllers/filters/boolean-filter';
import {
	useFiltersDiscoverability2Enabled,
	usePrimaryProduct,
} from '../../../../../controllers/store/bootstrap';
import { filter as watchedFilter } from '../../../../../controllers/store/search/filters/watched';

import { i18n } from './messages';

export type WatchedFilterProps = {
	isFilterInDropdown?: boolean;
};

const WatchedFilter = ({
	isFilterInDropdown = false,
	showPrimaryProductIcon,
	onFilterChange,
}: FilterProps): React.JSX.Element | null => {
	const { formatMessage } = useIntl();
	const [primaryProduct] = usePrimaryProduct();
	const isFiltersDiscoverability2Enabled = useFiltersDiscoverability2Enabled();
	const [state, { toggle }] = useBooleanFilter({
		filterId: watchedFilter.id,
	});

	if (!state || !fg('rovo_search_jira_watched_by_me_filter')) {
		return null;
	}

	const { value, autoFocus } = state;

	return (
		<ToggleFilter
			onChange={() => {
				onFilterChange?.({ isSelected: value });
				toggle();
			}}
			isChecked={value}
			autoFocus={autoFocus}
			isFilterInDropdown={isFilterInDropdown}
			isFiltersDiscoverability2Enabled={isFiltersDiscoverability2Enabled}
			iconBefore={
				<FilterProductIcon
					primaryProduct={primaryProduct}
					showPrimaryProductIcon={showPrimaryProductIcon}
				/>
			}
		>
			{formatMessage(i18n.watchedByMe)}
		</ToggleFilter>
	);
};

export default WatchedFilter;
